/**
 * MobileFilterSheet Component
 * Mobile-friendly filter drawer for CategoryPage
 */
import React from 'react';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '../ui/sheet';
import { Filter } from 'lucide-react';

const MobileFilterSheet = ({
  open,
  onOpenChange,
  title = "Filters",
  triggerClassName = "lg:hidden",
  children
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={triggerClassName}
          data-testid="mobile-filter-trigger"
        >
          <Filter className="h-4 w-4 mr-2" />
          {title}
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[320px] overflow-y-auto p-0">
        <SheetHeader className="p-4 border-b">
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <div className="overflow-y-auto max-h-[calc(100vh-80px)]">
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileFilterSheet;
